import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { CampaignForm } from "@/components/seller-promotions/campaign-form"
import {
	type CampaignFormValues,
	toCreateCampaignInput,
} from "@/components/seller-promotions/campaign-form.helpers"
import { useAdminRoles } from "@/hooks/use-admin-roles"
import { useCreateSellerPromotion } from "@/queries/marketplace"

export const Route = createFileRoute("/seller-promotions/new")({
	component: CreateSellerPromotionPage,
})

function CreateSellerPromotionPage() {
	const navigate = useNavigate()
	const createMutation = useCreateSellerPromotion()
	const { hasRole, isLoading: rolesLoading } = useAdminRoles()

	const handleSubmit = useCallback(
		async (values: CampaignFormValues) => {
			const campaign = await createMutation.mutateAsync(
				toCreateCampaignInput(values),
			)
			navigate({
				to: "/seller-promotions/$campaignId",
				params: { campaignId: campaign.id },
			})
		},
		[createMutation, navigate],
	)

	if (!rolesLoading && !hasRole(AdminRole.MarketplaceFinance)) {
		return (
			<div className="p-6">
				<p className="text-muted-foreground">
					Only admins with the finance role can create seller promotions.
				</p>
			</div>
		)
	}

	return (
		<CampaignForm
			mode="create"
			onSubmit={handleSubmit}
			isSubmitting={createMutation.isPending}
		/>
	)
}
